import "./style.css"
import React, { lazy, Suspense, useEffect, useState } from 'react'
import Navbar from './component/Navbar';
import Loading from "./component/Loading.jsx";
import Skil from './component/Skil';

import Biodata from "./component/Biodata";
import FrequentlyAsked from "./component/FrequentlyAsked.jsx";

import { BrowserRouter } from 'react-router-dom';

import Pertical from "./component/Pertical";
const About = lazy(() => import("./component/About.jsx"));
const Project = lazy(() => import('./component/Project'));
const CountUp = lazy(() => import('./component/Countup'));

const Footer = lazy(() => import("./component/Footer"));


function App() {
  const [isloading, setIsLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 2000)
  })
  return (
    <>
      {isloading ?
        (<Loading />)
        :
        (
          <BrowserRouter>
            <Navbar />
            <Biodata />
            <Pertical />
            <Suspense fallback={<p>Loading...</p>}>

              <About />
              <Project />
              <Skil />
              <CountUp />
              <FrequentlyAsked />
              <Footer />
            </Suspense>

            {/* <Certification/> */}

          </BrowserRouter>
        )}
    </>
  );
}

export default App;
